import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { AlertController, LoadingController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { ImageResizer, ImageResizerOptions } from '@ionic-native/image-resizer';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { MarketplaceProvider } from '../../providers/marketplace/marketplace';
import { ExtraProvider } from '../../providers/extra/extra';
import { ToastProvider } from '../../providers/toast/toast';
import { Ng2ImgToolsService } from 'ng2-img-tools';
import { Storage } from '@ionic/storage';
import { UtilService } from '../../services/util';
import { MarketplacecategoryPage } from '../marketplacecategory/marketplacecategory';
import { InAppBrowser, InAppBrowserOptions, InAppBrowserObject } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';


declare let window: any; 
/**
 * Generated class for the MarketplaceAddOfferPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-marketplace-add-offer',
  templateUrl: 'marketplace-add-offer.html',
})
export class MarketplaceAddOfferPage {
  categoryName : any;
  addItem = []
  loading = false;
  imagesUrl = []
  imgUrl = [];
  marketuuid :any;
  societyuuid :any;
  categoryuuid :any;
  disableBtn = true;
  acceptBox :any;
  allUsersList:any;
  privacyPolicy : any;

  date: Date;
  today: Date;
  maxDate : Date;
normalAns : any ;

  data: any;
  events: any;
  visit = "asap";
  commonAreas = [];
  uploaded: boolean = false;
  disableDesc = true;
  customAreas: any;
  compressing = false;
  isAndroid = true;

  options: CameraOptions = {
    quality: 90,
    destinationType: this.camera.DestinationType.FILE_URI,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    correctOrientation: true,
    saveToPhotoAlbum: false,
  }

  item: any;

  constructor(public navCtrl: NavController,
    private camera: Camera, 
    private imageResizer: ImageResizer,
    private marketplaceprovider: MarketplaceProvider,
     public navParams: NavParams,
     private ref: ChangeDetectorRef,
     private translate: TranslateService,
     private extra: ExtraProvider,
     private toast: ToastProvider,
     private viewCtrl :ViewController,
     private alertCtrl: AlertController,
     private platform: Platform,
     private storage: Storage,
     private util: UtilService,
     private inAppBrowser:InAppBrowser,
     private imageTools: Ng2ImgToolsService) {
      this.isAndroid = this.platform.is('android');
      this.today = new Date();
      this.maxDate = new Date();
      this.maxDate.setDate(this.maxDate.getDate() + 30);
      console.log(this.maxDate)
      this.date = this.today;
      this.categoryName = this.navParams.get("categoryName");
      this.marketuuid = this.navParams.get("marketuuid");
      this.societyuuid =this.navParams.get("societyuuid");
      this.categoryuuid =this.navParams.get("categoryuuid");
      this.allUsersList =this.navParams.get("userList");
     
    //  this.privacyPolicy = " <p style='color:#000;text-align:justify'  class='privacy-policy'>These Terms of Service are a contract (“T&C”) between you and iSocietyManager. They govern your use of iSocietyManager’s sites, its subsidiary site,  services, mobile apps, products, and content. It is referred as (“Services”). <br>  By using iSocietyManager, you agree to these T&C. If you don’t agree to any of the T&C, you can’t use iSocietyManager. <br>  We can change these T&C at any time. We keep a historical record of all changes to our T&C. If a change is material, we’ll let you know before they take effect. By using ISocietyManager on or after that effective date, you agree to the new T&C. If you don’t agree to them, you should delete your account before they take effect, otherwise your use of the site and content will be subject to the new T&C.</p>"
    
    
    // this.privacyPolicy =  this.OpenUrl();


  }

  submit(){
    console.log(this.addItem); 
     console.log(this.imgUrl.length)
    if(this.imgUrl.length == 0){
      this.toast.presentToast("Please Upload Image ");
      return true;
    }
    if(!this.addItem['name']){
      this.toast.presentToast("Please Enter Offer Name");
      return true;
    }
    if(!this.addItem['description']){
      console.log("hello descrption " )
      this.toast.presentToast("Please Enter Offer Description");
      return true;
    }
    if(this.addItem['price'] < this.addItem['price_off']   ){
      this.toast.presentToast("Discount will be Smaller than Price");
      return true;
    }
    if(this.addItem['price'] == !NaN ){
      this.toast.presentToast("Price Will be Numeric Value");
      return true;
    }
    if(this.addItem['seller_phone']){
      if(this.addItem['seller_phone'] == !NaN  ){
        this.toast.presentToast("Please Enter Correct Mobile Number ");
        return true;
      }
    if(this.addItem['seller_phone'].length  != 10 ){
      this.toast.presentToast("Please Enter Correct Mobile Number ");
      return true;
    }
  }
    
    this.marketplaceprovider.addOffer(this.societyuuid,this.marketuuid,this.categoryuuid,this.addItem,this.imgUrl).then(val => {
      this.toast.presentToast(val.message);
      if(val.status == 'success'){

        this.navCtrl.push(MarketplacecategoryPage, {
          name: this.categoryName,
          uuid: this.categoryuuid,
          marketuuid: this.marketuuid,
          societyuuid: this.societyuuid,
          userList : this.allUsersList,
        });

      }
    })
  }

  acceptPolicy(item){

    if(item == undefined || item == false)
    {
      var url= 'http://test.isocietymanager.com/static/admin/view/market-place-policy.html';
      this.openWithInAppBrowser(url);
      this.disableBtn = false;
    }
    else{
      this.disableBtn = true;
    }
  }


// OpenUrl()
// {
// const browser = this.inAppBrowser.create('');
// browser.show()
// }


openWithInAppBrowser(url : string){
  let options : InAppBrowserOptions = {
    hidenavigationbuttons : 'no',
    footer : 'yes',
    location : 'no',//Or 'no' 
    hidden : 'no', //Or  'yes'
    clearcache : 'yes',
    clearsessioncache : 'yes',
    zoom : 'yes',//Android only ,shows browser zoom controls 
    hardwareback : 'no',
    mediaPlaybackRequiresUserAction : 'no',
    shouldPauseOnSuspend : 'no', //Android only 
    closebuttoncaption : 'Done', //iOS only
    disallowoverscroll : 'no', //iOS only 
    toolbar : 'yes', //iOS only 
    enableViewportScale : 'no', //iOS only 
    allowInlineMediaPlayback : 'no',//iOS only 
    presentationstyle : 'pagesheet',//iOS only 
    fullscreen : 'yes',//Windows only  
  };
  
  let target = "_blank";
  var obj1 = this.inAppBrowser.create(url,target,options);
  obj1.on('exit').subscribe( (obj)=>{
    try{
      this.events.publish('policy-browser:exit', obj);
    }catch(e){
      console.log(e);
    }
  })
}


//   promt(){
//     let actions = [{text: 'Decline',  handler: data => {} }];
//     actions.push({
//       text: 'Acccept',
//       handler: data => {
//         if(this.disableBtn = true){
//           this.disableBtn = false;
//         }else{
//         this.disableBtn = true;
//         this.acceptBox = false;
//         }  
//       }
//     }
//       );
//       const prompt = this.alertCtrl.create({
//     title: 'Term and Condition',
//     // message: this.privacyPolicy openWithInAppBrowser,
//     message :  this.privacyPolicy,
//     cssClass:'prompt_alert_policy',
//     buttons: actions
//   });
//   prompt.present();
// }

  dismiss() {
    this.viewCtrl.dismiss();
    this.addItem = []
    this.imagesUrl = []
    this.imgUrl = [];
  }


  takePicture() {
    this.camera.getPicture(this.options).then((imageUri) => {
      let imgUri = imageUri;

      let options = {
        uri: imgUri,
        folderName: "isociety",
        quality: 90,
        width: 500,
        height: 500,
        fileName: 'resize.jpg' 
      } as ImageResizerOptions;
       
      this.imageResizer.resize(options).then((uri: string) => {
        console.log("resized file");
        console.log(uri);
        return this.extra.convertUriToBase64IOS(uri).then(val => {
          this.imgUrl.push(val.base64File);
          // this.imgUrl = val.base64File;
          this.imagesUrl.push({urlPath:val.base64File})
          this.uploaded = true;
        })
      }).catch(e => this.displayErrorAlert(e));

    }, (err) => {
       this.displayErrorAlert(err);
    });
          
  };


  displayErrorAlert(err){
    console.log(err);
    // let alert = this.alertCtrl.create({
    //     title: 'Error',
    //     subTitle: 'Error while trying to capture picture',
    //     buttons: ['OK']
    //   });
    // alert.present();
  }


  fileChoose(){
    console.log("yes click")
    if(this.platform.is('ios')){
      this.extra.imgPicker().then(val => {
        console.log(val)
        var file = 'data:image/jpeg;base64,' + val[0]
        this.imgUrl.push(file);
        // this.imgUrl = file;
        this.imagesUrl.push({urlPath:file})
        this.uploaded = true;
        this.ref.detectChanges();
      });
    }else{
      this.extra.chooseFile().then(val => {
        console.log(val)
        val.fileEntry.getMetadata(metadata => {
          if(metadata.size < 2000000){
            if(val.file && (val.file.slice(-3) == "jpg" || val.file.slice(-3) == "png" || val.file.slice(-4) == "jpeg")){
              this.imgUrl.push(val.base64File);
              // this.imgUrl = val.base64File;
              this.imagesUrl.push({urlPath:val.base64File})
              console.log(this.imgUrl)
              this.uploaded = true;
              this.ref.detectChanges();
            }else{
              this.toast.presentToast("file should be an image");
            }
          }else {
            this.toast.presentToast("file size is greater than 2mb");
          }
        });
      });
    }
  }

  closeImg(){
    this.uploaded = false;
    this.imgUrl = null;
    this.ref.detectChanges();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad MarketplaceAddOfferPage');
  }

  changeListener($event) : void {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    var file:File = inputValue.files[0];
    this.compressing = true;
    this.imageTools.resize([file], 500, 500).subscribe(val => {
      var reader = new FileReader();
      reader.readAsDataURL(val); 
      reader.onloadend = () => {
        this.imgUrl.push(reader.result);
        this.imagesUrl.push({urlPath:reader.result})
        console.log(this.imagesUrl)
        this.uploaded = true;        
      }
      this.compressing = false;
    }, err => {
      this.compressing = false;
      this.toast.presentToast("Unable to compress");
      console.log(err);
    });
  }





}




// WEBPACK FOOTER //
// ./src/pages/marketplace-add-offer/marketplace-add-offer.ts